import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, EMPTY, of } from 'rxjs';
import { Farm, Cultivation, User, farmConfig } from '../_models/index';
import { HandleService, HttpRequestService } from '../_services/index';
import { environment } from '../../environments/environment'
import { JarvisUiService } from '../modules/jarvis-ui/jarvis-ui.service';
import { map } from 'rxjs/operators';
import { localStorageService } from './local-storage.service';

const GETFARM_ACTION = environment.BeApiOperational.getfarms;
const GETCAMPAGNE_ACTION = environment.BeApiOperational.getcampagne;
const GETCULTURE_ACTION = environment.BeApiOperational.getcultures;
const GETFILTER_ACTION = environment.BeApiOperational.getfilter;
const GETUSERINFO_ACTION = environment.BeApiOperational.getuserinfo;

@Injectable()
export class FarmServices extends BehaviorSubject<Farm[]> {
    private baseUrl = environment.BeApiOperational.url;

    //les orders chargés
    private _filteredOrders: Farm[] = [];

    //liste des identifiants des orders chargés en interface
    private _ordersIds: string[] = [];

    //dictionnaires des orders Id et steps
    private _ordersPrestas: Record<string, number> = {};

    /**liste des identifiants des orders chargés en interface */
    public get FilteredOrdersIds(): string[] {
        return this._ordersIds;
    }

    /**liste des identifiants des exploitations chargées en interface */
    public FilteredFarmsIds(): string[] {
        return this._filteredOrders?.map(t => t.IdExploitation);
    }

    /**Retourne la liste des identifiants d'order de type conseil (PK N PACK GRCETA) */
    public GetOrderIdsOnAdvicePrestation(): string[] {

        //FOData = 2 & EpiclesReturn = 4 & GRCETA = 12
        return HandleService.GetKeysByValues(this._ordersPrestas, [2, 4, 12])
    }
    /**Retourne la liste des identifiants d'order de Commande Pilot SP */
    public GetOrderIdsOnPilotSPPrestation(): string[] {
        //OrderSpLai = 9
        return HandleService.GetKeysByValue(this._ordersPrestas, 9)
    }

    /**liste des orders chargés en interface */
    public get FilteredOrders(): Farm[] {
        return this._filteredOrders;
    }

    /**les orders chargés */
    public set FilteredOrders(value: Farm[]) {
        this._filteredOrders = value;
        this.BindOrderIdSelected();
    }

    /**
     * on remplace les données orders (farms)
     * ce qui provoque le rechargement des données legendes carto...
     * @param value 
     */
    public ReloadFrontOrdersDatas(value: Farm[]) {
        this.FilteredOrders = value;
    }

    constructor(private _jarvisMenuService: JarvisUiService, private httpRequestService: HttpRequestService) {
        super([]);
    }

    /**
     * Retourne les informations utilisateur selon celui connecté (token smag)
     * @returns 
     */
    getuserinfo(): Observable<User> {
        // on vérifie si les données sont déjà stockées
        const storedUserInfo = localStorageService.get('userInfo');
        if (storedUserInfo) {
            const userInfoData = JSON.parse(storedUserInfo);
            //on convertit les données pour le typage
            const userInfo = this.convertJsonToUserInfo(userInfoData);
            return of(userInfo);
        }
        //le token smag est automatiquement ajouté dans le header lors de l appel il identifie l'utilisateur
        const body = {};
        return this.httpRequestService.PostRequest(this.baseUrl + GETUSERINFO_ACTION, body, 'getuserinfo').pipe(
            map(
                (response) => {
                    const userInfo = response;
                    const converted = this.convertJsonToUserInfo(userInfo);
                    localStorageService.set('userInfo', JSON.stringify(converted));
                    return converted
                })
        );
    }

    /**
     * Retourne les exploitations accessible à l'utilisateur connecté
     * @param allFarms 
     * @returns 
     */
    public getFarms(allFarms: boolean) {
        
       //le token smag est automatiquement ajouté dans le header lors de l appel il identifie l'utilisateur
        const body = {};
        return this.httpRequestService.PostRequest(this.baseUrl + GETFARM_ACTION, body, 'getFarms')
            .pipe(
                map(
                    (response) => {
                        return this.convertJsonToFarm(response, allFarms);
                    })
            );
    }


    public getCampagnes(farmsId: string[]):Observable<number[]> {
       
        const body = { "FarmsId": farmsId };
        return this.httpRequestService.PostRequest(this.baseUrl + GETCAMPAGNE_ACTION, body, 'getCampagnes').pipe(
            map(
                (response) => {
                    return this.convertJsonToCampagneList(response);
                })
        );
    }

    /**
     * Retourne les exploitation selon la camapgne et culture si présente
     * @param farmsId 
     * @param idCampaign 
     * @param cultivations 
     * @param preserveMemory on preserve dans le service les epxloitations recupérée comme order filtered
     * @returns 
     */
    public GetFarmByCultivationsFiltered(farmsId: string[], idCampaign: number, cultivations: Cultivation[], preserveMemory: boolean = true) {
        const body = { "FarmsId": farmsId, "IdCampaign": idCampaign, "Cultivations": cultivations };

        return this.httpRequestService.post(this.baseUrl + GETFILTER_ACTION, body, 'GetFarmByCultivationsFiltered').pipe(
            map(
                (response) => {
                    let apps = response;
                    return this.convertJsonToFarm(apps, false);
                })
        );
    }


    public getCultivations(farmsId: string[], idCampaign: number) {

        const body = { idCampaign, farmsId };
        return this.httpRequestService.PostRequest(this.baseUrl + GETCULTURE_ACTION, body, 'getCultivations').pipe(
            map(
                (response) => {
                    let apps = response;
                    return this.convertJsonToCultivations(apps);
                })
        );

    }

    /**
     * 
     * @param _iJsonFarms json back d'exploitations 
     * @param allFarm true on retourne l'ensemble des exploitations de l'utilisateur et enregistré en storage false on remplit this.FilteredOrders
     * @param preserveMemory si true remplis this.FilteredOrders Si pas allfarms
     * @returns 
     */
    private convertJsonToFarm( _iJsonFarms: any[], allFarm: boolean, preserveMemory: boolean = true): Farm[] {
        let oFarms = new Array<Farm>();
        if (!_iJsonFarms || _iJsonFarms.length === 0)
            return oFarms;

        if (_iJsonFarms)
            _iJsonFarms.forEach((element, i) => {
                oFarms[i] = new Farm(element);
            });

        if (allFarm) {
            let currentUser = localStorageService.GetJsonLogin(true);
               
            let farms = localStorageService.GetJsonUserFarms();

            if (farms == null || !farms.length){
                farms = {};
            }
               

            farms[currentUser.userid] = oFarms;
       
            localStorageService.SetUserFarms(farms);
           
        }
        else if (preserveMemory == true) {
            this.FilteredOrders = oFarms;
        }

        return oFarms;
    }

    convertJsonToUserInfo(_iJsonPersonalInfo: any): User {
        let convertedInfo: User = new User();
        if (_iJsonPersonalInfo.UserInfo != null) {
            if (_iJsonPersonalInfo.UserInfo.FirstName != undefined)
                convertedInfo.Firstname = _iJsonPersonalInfo.UserInfo.FirstName;
            else
                convertedInfo.Firstname = '';

            if (_iJsonPersonalInfo.UserInfo.LastName != undefined)
                convertedInfo.Lastname = _iJsonPersonalInfo.UserInfo.LastName;
            else
                convertedInfo.Lastname = '';
        }

        if (_iJsonPersonalInfo && _iJsonPersonalInfo.Role != undefined) {
            convertedInfo.Role = _iJsonPersonalInfo.Role;
        } else {
            convertedInfo.Role = "";
        }
        return convertedInfo;
    }


    /**
     * Conversion des cultures back json en cultivations
     * @param _iJsonCultivations cultures back
     * @returns Cultivation[]
     */
    private convertJsonToCultivations(_iJsonCultivations: any[]): Cultivation[] {
        let oConvertedApps = new Array<Cultivation>();
        if (_iJsonCultivations)
            _iJsonCultivations.forEach((fCultivation: any) => {
                if (fCultivation != null) {
                    let nwCultivation = new Cultivation(fCultivation.Id, fCultivation.Name, fCultivation.Color, fCultivation.Code);
                    if (nwCultivation.Name == null) {
                        nwCultivation.Name = "Non défini(e)";
                    }
                    oConvertedApps.push(nwCultivation);
                }

            });
        return oConvertedApps;
    }

    private convertJsonToCampagneList(_iJsonCampaign: any): number[] {
        let convertedApps = new Array<number>();
        
        convertedApps = _iJsonCampaign.CampagnesValues.sort(function (a: number, b: number) { return b - a });;
        return convertedApps;

    }

    /**
     * depuis les orders chargé complète la liste des identifiants de ceux-ci
     */
    private BindOrderIdSelected() {
        this._ordersIds = [];
        this._ordersPrestas = {};
        if (this.FilteredOrders?.length) {
            this.FilteredOrders.forEach(
                (fOrder: Farm) => {
                    this._ordersIds.push(fOrder.OrderUid)
                    this._ordersPrestas[fOrder.OrderUid] = fOrder.Step
                }
            )
        }

    }

    //Retourne un observable VIDE
    public GetEmptyFarmArray(): Observable<Farm[]> {
        return EMPTY;
    }


    public static IncludePlotModulation(_iFarm: Farm): boolean {
        return (_iFarm.Sectors && _iFarm.Sectors.find(r => r.CultivationPlots != null && r.CultivationPlots.length && r.CultivationPlots.find(pl => pl.Preconisations && pl.Preconisations.length > 0) != null) != null)
    }


    public static IncludeModePreco(_iFarm: Farm): boolean {
        return _iFarm.HasModePreco();
    }
}
